import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { getSemanticColors, SemanticColor } from '../../theme/colors';
import { ErrorAnimationView } from './ErrorAnimationView';

export const ErrorAnimation: React.FC<TWidgetProps<TCommonData>> = ({ widget }) => {
    return <ErrorAnimationView uid={widget.uid} margin={widget.options?.margin} animationsColor={getSemanticColors(widget.version)[SemanticColor.IconError]} />;
};
